// ----------------------------------------------------------------------------
// Component: Author Articles
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';

// Styles
import './_author-articles.scss';